var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.initialWeight
      ? _c("p", [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t(
                  "health",
                  "You started with {initialWeight}{unit} for your target.",
                  _vm.transValues
                )
              ) +
              "\n\t"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.weight && _vm.target
      ? _c("p", [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t(
                  "health",
                  "Your actual weight is now {weight}{unit} and your target values {target}{unit}.",
                  _vm.transValues
                )
              ) +
              "\n\t"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.weight && !_vm.target
      ? _c("p", [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t(
                  "health",
                  "Your actual weight is now {weight}{unit}.",
                  _vm.transValues
                )
              ) +
              "\n\t"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.weight > _vm.target && _vm.weight <= _vm.initialWeight
      ? _c(
          "p",
          [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.t(
                    "health",
                    "You lost already {diff}{unit} and you have {toGo}{unit} to go.",
                    _vm.transValues
                  )
                ) +
                "\n\t\t"
            ),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.t("health", "Go on and eliminate the blue bar:", {})
                ) +
                "\n\t\t"
            ),
            _c("ProgressBar", {
              class: { small: true },
              attrs: { value: _vm.getProgressbarValue }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.weight > _vm.initialWeight && _vm.initialWeight !== null
      ? _c("p", { staticClass: "alert red" }, [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t(
                  "health",
                  "Ups, you become more and more. Be careful!",
                  {}
                )
              ) +
              "\n\t"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.weight <= _vm.target
      ? _c("p", { staticClass: "green alert" }, [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.t("health", "Good, you reached your target!", {})) +
              "\n\t"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.weight <= _vm.target && _vm.bounty
      ? _c("p", { staticClass: "bountyBox green" }, [
          _vm._v("\n\t\t" + _vm._s(_vm.bounty) + "\n\t")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }